<template>
  <div class="Bgc-white">
    <Header />
    <div class="contentContacto">
      <div class="container contacto">
        <div class="row">
          <div class="col-12 mb-3">
            <p class="title">{{$t('language.posadasCorporate.ayudaCorporate.ayudaCorporate')}}</p>
            <p>{{$t('language.posadasCorporate.ayudaCorporate.body')}}</p>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <b-card :title="$t('language.posadasCorporate.ayudaCorporate.telefono')" tag="article" style="max-width: 20rem;" class="mb-2">
              <b-card-text>
                {{$t('language.posadasCorporate.ayudaCorporate.telefonoDisponible1')}}
                {{$t('language.posadasCorporate.ayudaCorporate.telefonoDisponible2')}}
              </b-card-text>

              <div class="enlacesContacto mb-2">
                <i class="demo-icon icon-telephone"> </i>
                {{$t('language.posadasCorporate.ayudaCorporate.mexico')}}: <a class="link" href="tel:44 3298 2253">44 3298 2253</a>
              </div>
              <div class="enlacesContacto">
                <i class="demo-icon icon-telephone"> </i>
                {{$t('language.posadasCorporate.ayudaCorporate.usa')}}: <a class="link" href="tel:1 800 3437 821">1 855 26 36 094</a>
              </div>
            </b-card>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <b-card :title="$t('language.posadasCorporate.ayudaCorporate.mensajeriaInstantanea')" tag="article" style="max-width: 20rem;"
              class="mb-2">
              <b-card-text>
                {{$t('language.posadasCorporate.ayudaCorporate.mensajeriaInstantaneaDisponible1')}}
                {{$t('language.posadasCorporate.ayudaCorporate.mensajeriaInstantaneaDisponible2')}}
              </b-card-text>

              <div class="enlacesContacto mb-2">
                <i class="demo-icon icon-whatsapp"> </i>
                <a class="link" href="https://api.whatsapp.com/send?phone=5214431378728&text=Hola,%C2%BFMe%20pueden%20ayudar?">44 3137 8728</a>
              </div>
              <div class="enlacesContacto">
                <i class="demo-icon icon-chat"> </i>
                <a class="link" @click="chatLine">{{$t('language.posadasCorporate.ayudaCorporate.chat')}}</a>
              </div>
            </b-card>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <b-card :title="$t('language.posadasCorporate.ayudaCorporate.email')" tag="article" style="max-width: 20rem;"
              class="mb-2">
              <b-card-text>
                {{$t('language.posadasCorporate.ayudaCorporate.emailDisponible1')}}
                {{$t('language.posadasCorporate.ayudaCorporate.emailDisponible2')}}
              </b-card-text>

              <div class="enlacesContacto mb-2">
                <i class="demo-icon icon-mail"> </i>
                <a class="link" href="mailto:soportecorporate@posadas.com">soportecorporate@posadas.com</a>
              </div>

            </b-card>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import SecureLS from 'secure-ls';
  import Header from '../../generales/Header.vue';
  import Footer from '../../generales/Footer.vue';

  export default {
    name: 'Contacto',
    components: {
      Header,
      Footer,
    },
    data() {
      return{
        ls: new SecureLS({ encodingType: "aes" }),
        language: ''
      }
    },
    methods: {
     	chatLine() {
        this.language = this.ls.get('Language'); 
          if( this.language.data == 'es' && this.language.data != '' ) {
            window.open(process.env.VUE_APP_CHATES, '_blank');
          } else {
            window.open(process.env.VUE_APP_CHATEN, '_blank');
          }
        }
    }
  }

</script>

<style lang="scss">
  @import '../../../assets/scss/config.scss';

  .contentContacto {
    display: flex;
    position: relative;
    min-height: 70vh;
  }

  .contacto {
    width: 100% !important;
    margin-top: 57px !important;
    padding-top: 32px !important;

    .card-body {
      min-height: 181px;

      .card-title {
        font-size: $font-size-large;
      }
    }
  }

  .enlacesContacto {
    color: $colorBase2;
    font-weight: 500;

    .demo-icon {
      font-size: $font-size-biglarge;
    }
  }

</style>
